const setButtonHoverOrigin = (event) => {
  const button = event.currentTarget;
  const rect = button.getBoundingClientRect();
  button.style.setProperty('--ds-button-x', `${event.clientX - rect.left}px`);
  button.style.setProperty('--ds-button-y', `${event.clientY - rect.top}px`);
};

const bindButtonHoverOrigin = () => {
  document.querySelectorAll('.ds-button, .ds-flavor-card__button, .ds-product__flavor, .ds-product__duration, .ds-product__add').forEach((button) => {
    button.removeEventListener('pointerenter', setButtonHoverOrigin);
    button.removeEventListener('pointermove', setButtonHoverOrigin);
    button.addEventListener('pointerenter', setButtonHoverOrigin);
    button.addEventListener('pointermove', setButtonHoverOrigin);
  });
};

bindButtonHoverOrigin();
document.addEventListener('shopify:section:load', bindButtonHoverOrigin);

const bindAnnouncementRotators = () => {
  document.querySelectorAll('[data-ds-announcement-rotator]').forEach((rotator) => {
    if (rotator.dataset.dsAnnouncementBound === 'true') return;
    const items = Array.from(rotator.querySelectorAll('[data-ds-announcement-item]'));
    if (items.length <= 1) return;

    rotator.dataset.dsAnnouncementBound = 'true';
    let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));

    window.setInterval(() => {
      items[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % items.length;
      items[activeIndex].classList.add('is-active');
    }, 5000);
  });
};

bindAnnouncementRotators();
document.addEventListener('shopify:section:load', bindAnnouncementRotators);

const bindSectionReveals = () => {};

bindSectionReveals();
document.addEventListener('shopify:section:load', bindSectionReveals);

const getSwiperOptions = (slider) => {
  const type = slider.dataset.dsSwiper;
  const section = slider.closest('section') || slider;

  const baseOptions = {
    slidesPerView: 'auto',
    watchOverflow: true,
    grabCursor: true,
    speed: 520,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
      releaseOnEdges: true,
      sensitivity: 1,
    },
  };

  if (type === 'ingredients') {
    return {
      ...baseOptions,
      slidesPerView: 'auto',
      spaceBetween: window.innerWidth >= 1200 ? 28 : 24,
      navigation: {
        prevEl: section.querySelector('[data-ds-slider-prev]'),
        nextEl: section.querySelector('[data-ds-slider-next]'),
      },
      pagination: {
        el: section.querySelector('.ds-ingredients__pagination'),
        clickable: true,
        bulletClass: 'ds-ingredients__dot',
        bulletActiveClass: 'ds-ingredients__dot--active',
      },
    };
  }

if (type === 'action') {
  const wrapper = slider.querySelector('.swiper-wrapper');
  const originalSlides = [...wrapper.children];

  while (wrapper.children.length < 12) {
    originalSlides.forEach((slide) => {
      wrapper.appendChild(slide.cloneNode(true));
    });
  }

  return {
    ...baseOptions,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopPreventsSliding: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    spaceBetween: window.innerWidth >= 1200 ? 34 : 18,
  };
}

  if (type === 'reviews') {
    return {
      ...baseOptions,
      slidesPerView: 1.3,
      spaceBetween: window.innerWidth >= 1200 ? 40 : window.innerWidth >= 750 ? 20 : 14,
      breakpoints: {
        750: {
          slidesPerView: 2.2,
        },
        1200: {
          slidesPerView: 'auto',
        },
      },
      navigation: {
        prevEl: section.querySelector('[data-ds-reviews-prev]'),
        nextEl: section.querySelector('[data-ds-reviews-next]'),
      },
      pagination: {
        el: section.querySelector('.ds-reviews__pagination'),
        clickable: true,
        bulletClass: 'ds-reviews__dot',
        bulletActiveClass: 'ds-reviews__dot--active',
      },
    };
  }

  if (slider.classList.contains('ds-how__slider')) {
    return {
      ...baseOptions,
      watchOverflow: false,
      slidesPerView: 1.08,
      spaceBetween: 24,
    };
  }

  return {
    ...baseOptions,
    spaceBetween: 4,
  };
};

const setupSwiper = (slider) => {
  if (!window.Swiper) {
    slider.classList.remove('ds-swiper-ready');
    return;
  }

  const type = slider.dataset.dsSwiper;
  const shouldUseSwiper = type !== 'mobile' || window.innerWidth < 1200;

  if (!shouldUseSwiper) {
    if (slider.dsSwiperInstance) {
      slider.dsSwiperInstance.destroy(true, true);
      slider.dsSwiperInstance = null;
    }
    slider.classList.remove('ds-swiper-ready');
    return;
  }

  if (slider.dsSwiperInstance) {
    slider.dsSwiperInstance.update();
    slider.classList.add('ds-swiper-ready');
    return;
  }

  slider.classList.add('ds-swiper-ready');
  slider.dsSwiperInstance = new window.Swiper(slider, getSwiperOptions(slider));
};

const bindSwipers = () => {
  document.querySelectorAll('[data-ds-swiper]').forEach(setupSwiper);
};

bindSwipers();
window.addEventListener('resize', bindSwipers);
document.addEventListener('shopify:section:load', bindSwipers);

const bindHowScrollTrigger = () => {
  document.querySelectorAll('.ds-how').forEach((section) => {
    if (section.dataset.dsHowScrollBound === 'true') return;
    section.dataset.dsHowScrollBound = 'true';

    const slider = section.querySelector('.ds-how__slider');
    const sectionWrapper = section.closest('.shopify-section');
    const getSwiper = () => slider?.dsSwiperInstance || null;
    const dots = Array.from(section.querySelectorAll('.ds-how__dot'));
    let ticking = false;
    let lastIndex = -1;

    const getSlideCount = () => {
      return slider?.querySelectorAll('.swiper-slide').length || getSwiper()?.slides?.length || 1;
    };

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('ds-how__dot--active', dotIndex === index);
      });
    };

    const syncPinnedHeight = () => {
      const swiper = getSwiper();
      const slideCount = getSlideCount();
      const shouldPin = window.innerWidth < 1200 && swiper && slideCount > 1;

      section.classList.toggle('ds-how--scroll-trigger', Boolean(shouldPin));
      sectionWrapper?.classList.toggle('ds-how-section-pinned', Boolean(shouldPin));

      if (!shouldPin) {
        section.style.removeProperty('--ds-how-pin-height');
        lastIndex = -1;
        if (swiper) swiper.allowTouchMove = true;
        return;
      }

      section.classList.add('is-visible');
      section.style.setProperty('--ds-how-pin-height', `${window.innerHeight + (window.innerHeight * (slideCount - 1))}px`);
      swiper.update();
      swiper.allowTouchMove = false;
      setActiveDot(Math.max(0, lastIndex));
    };

    const updateSlideFromScroll = () => {
      ticking = false;
      const swiper = getSwiper();
      if (window.innerWidth >= 1200 || !swiper) return;

      const rect = section.getBoundingClientRect();
      const scrollableDistance = section.offsetHeight - window.innerHeight;
      if (scrollableDistance <= 0 || rect.top > 0 || rect.bottom < window.innerHeight) return;

      const progress = Math.min(1, Math.max(0, Math.abs(rect.top) / scrollableDistance));
      const maxIndex = Math.max(0, getSlideCount() - 1);
      const nextIndex = Math.min(maxIndex, Math.round(progress * maxIndex));

      if (nextIndex !== lastIndex) {
        lastIndex = nextIndex;
        swiper.slideTo(nextIndex, 420);
        setActiveDot(nextIndex);
      }
    };

    const requestScrollUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSlideFromScroll);
    };

    const refresh = () => {
      syncPinnedHeight();
      requestScrollUpdate();
    };

    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    window.addEventListener('resize', refresh);
    document.addEventListener('shopify:section:load', refresh);
    window.setTimeout(refresh, 200);
    refresh();
  });
};

bindHowScrollTrigger();
document.addEventListener('shopify:section:load', bindHowScrollTrigger);

const bindTabs = () => {
  document.querySelectorAll('[data-ds-tabs]').forEach((tabs) => {
    tabs.querySelectorAll('[data-ds-tab-button]').forEach((button) => {
      if (button.dataset.dsTabsBound === 'true') return;
      button.dataset.dsTabsBound = 'true';

      button.addEventListener('click', () => {
        const target = button.dataset.dsTabTarget;
        if (button.classList.contains('is-active')) return;

        tabs.querySelectorAll('[data-ds-tab-button]').forEach((currentButton) => {
          const isActive = currentButton === button;
          currentButton.classList.toggle('is-active', isActive);
          currentButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        tabs.querySelectorAll('[data-ds-tab-panel]').forEach((panel) => {
          const isActive = panel.dataset.dsTabId === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  });
};

bindTabs();
document.addEventListener('shopify:section:load', bindTabs);

const bindComparisonScroll = () => {
  document.querySelectorAll('[data-ds-comparison-scroll]').forEach((scroller) => {
    if (scroller.dataset.dsComparisonBound === 'true') return;
    scroller.dataset.dsComparisonBound = 'true';

    const updateEdge = () => {
      const remaining = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft;
      scroller.classList.toggle('is-at-end', remaining <= 2);
      scroller.closest('.ds-comparison__scroll-wrap')?.classList.toggle('is-at-end', remaining <= 2);
    };

    scroller.addEventListener('scroll', updateEdge, { passive: true });
    window.addEventListener('resize', updateEdge);
    updateEdge();
  });
};

bindComparisonScroll();
document.addEventListener('shopify:section:load', bindComparisonScroll);

const bindFaqItems = () => {
  document.querySelectorAll('[data-ds-faq-item]').forEach((item) => {
    if (item.dataset.dsFaqBound === 'true') return;
    item.dataset.dsFaqBound = 'true';
    item.removeAttribute('open');

    const summary = item.querySelector('summary');
    const answer = item.querySelector('.ds-faq__answer');
    if (!summary || !answer) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (item.dataset.dsFaqAnimating === 'true') return;

      const opening = !item.open;
      const startHeight = `${item.offsetHeight}px`;
      if (opening) item.open = true;
      const endHeight = `${summary.offsetHeight + (opening ? answer.offsetHeight : 0)}px`;

      item.dataset.dsFaqAnimating = 'true';
      const animation = item.animate(
        { height: [startHeight, endHeight] },
        { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );

      animation.onfinish = () => {
        if (!opening) item.open = false;
        item.style.height = '';
        delete item.dataset.dsFaqAnimating;
      };
    });
  });
};

bindFaqItems();
document.addEventListener('shopify:section:load', bindFaqItems);

const getVideoEmbedMarkup = (videoUrl) => {
  if (!videoUrl) return '';

  let url;
  try {
    url = new URL(videoUrl, window.location.origin);
  } catch (error) {
    return '';
  }

  const isYouTube = url.hostname.includes('youtube.com') || url.hostname.includes('youtu.be');
  const isVimeo = url.hostname.includes('vimeo.com');
  const isVideoFile = /\.(mp4|webm|ogg)(\?.*)?$/i.test(url.pathname);

  if (isYouTube) {
    const id = url.hostname.includes('youtu.be') ? url.pathname.slice(1) : url.searchParams.get('v');
    if (!id) return '';
    return `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0" title="DayShift video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
  }

  if (isVimeo) {
    const id = url.pathname.split('/').filter(Boolean).pop();
    if (!id) return '';
    return `<iframe src="https://player.vimeo.com/video/${id}?autoplay=1" title="DayShift video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
  }

  if (isVideoFile) {
    return `<video src="${url.href}" controls autoplay playsinline></video>`;
  }

  return `<iframe src="${url.href}" title="DayShift video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
};

const closeVideoModal = () => {
  const modal = document.querySelector('[data-ds-video-modal]');
  if (!modal) return;
  modal.remove();
  document.documentElement.classList.remove('ds-video-modal-open');
};

const openVideoModal = (videoUrl) => {
  const markup = getVideoEmbedMarkup(videoUrl);
  if (!markup) return;

  closeVideoModal();

  const modal = document.createElement('div');
  modal.className = 'ds-video-modal';
  modal.setAttribute('data-ds-video-modal', '');
  modal.innerHTML = `
    <button class="ds-video-modal__backdrop" type="button" aria-label="Close video" data-ds-video-close></button>
    <div class="ds-video-modal__dialog" role="dialog" aria-modal="true" aria-label="DayShift video">
      <button class="ds-video-modal__close" type="button" aria-label="Close video" data-ds-video-close>&times;</button>
      <div class="ds-video-modal__media">${markup}</div>
    </div>
  `;

  document.body.appendChild(modal);
  document.documentElement.classList.add('ds-video-modal-open');
  modal.querySelectorAll('[data-ds-video-close]').forEach((button) => {
    button.addEventListener('click', closeVideoModal);
  });
};

const bindVideoCards = () => {
  document.querySelectorAll('[data-ds-video-trigger]').forEach((trigger) => {
    if (trigger.dataset.dsVideoBound === 'true') return;
    trigger.dataset.dsVideoBound = 'true';

    trigger.addEventListener('click', () => {
      openVideoModal(trigger.dataset.videoUrl);
    });
  });
};

bindVideoCards();
document.addEventListener('shopify:section:load', bindVideoCards);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeVideoModal();
});

const bindCartLinks = () => {
  document.querySelectorAll('[data-ds-cart-link]').forEach((link) => {
    if (link.dataset.dsCartBound === 'true') return;
    link.dataset.dsCartBound = 'true';

    link.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        event.preventDefault();
        cartDrawer.open();
      }
    });
  });
};

bindCartLinks();
document.addEventListener('shopify:section:load', bindCartLinks);

const bindSubscriptionConsent = () => {
  document.querySelectorAll('[data-ds-subscription-consent]').forEach((consent) => {
    if (consent.dataset.dsSubscriptionConsentBound === 'true') return;
    consent.dataset.dsSubscriptionConsentBound = 'true';

    const checkbox = consent.querySelector('[data-ds-subscription-consent-checkbox]');
    const ctas = consent.closest('.cart__ctas');
    const checkoutButton = ctas?.querySelector('[data-ds-subscription-checkout]');
    const acceleratedButtons = ctas?.querySelector('.additional-checkout-buttons');
    if (!checkbox || !checkoutButton) return;

    const syncConsentState = () => {
      const allowed = checkbox.checked;
      checkoutButton.disabled = !allowed;
      acceleratedButtons?.classList.toggle('ds-cart-accelerated-disabled', !allowed);
      acceleratedButtons?.setAttribute('aria-disabled', allowed ? 'false' : 'true');
    };

    checkbox.addEventListener('change', syncConsentState);
    syncConsentState();
  });
};

bindSubscriptionConsent();
document.addEventListener('shopify:section:load', bindSubscriptionConsent);
document.addEventListener('cart:update', () => {
  window.setTimeout(bindSubscriptionConsent, 120);
});

const bindProductHero = () => {
  document.querySelectorAll('[data-ds-product]').forEach((productHero) => {
    if (productHero.dataset.dsProductBound === 'true') return;
    productHero.dataset.dsProductBound = 'true';

    const variantInput = productHero.querySelector('[data-ds-product-variant-id]');
    const sellingPlanInput = productHero.querySelector('[data-ds-product-selling-plan]');
    const mainImage = productHero.querySelector('.ds-product__image');
    const flavorName = productHero.querySelector('[data-ds-product-flavor-name]');
    const purchaseTypeButtons = [...productHero.querySelectorAll('[data-ds-purchase-type]')];
    const planButtons = [...productHero.querySelectorAll('[data-ds-product-plan]')];
    const subscriptionPrice = productHero.querySelector('[data-ds-subscription-price]');
    const subscriptionCompare = productHero.querySelector('[data-ds-subscription-compare]');
    const subscriptionPerDelivery = productHero.querySelector('[data-ds-subscription-per-delivery]');
    const subscriptionDiscount = productHero.querySelector('[data-ds-subscription-discount]');
    const subscriptionPlanCopy = productHero.querySelector('[data-ds-subscription-plan-copy]');
    const productForm = productHero.querySelector('.ds-product__form');
    const addButton = productHero.querySelector('[data-ds-product-add]');

    productHero.querySelectorAll('[data-ds-product-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.dataset.image && mainImage) {
          mainImage.src = button.dataset.image;
          mainImage.srcset = '';
        }

        productHero.querySelectorAll('[data-ds-product-gallery-thumb]').forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });
      });
    });

    const setPurchaseType = (type) => {
      purchaseTypeButtons.forEach((button) => {
        const isActive = button.dataset.dsPurchaseType === type;
        button.classList.toggle('ds-product__purchase-card--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (sellingPlanInput) {
        sellingPlanInput.disabled = type !== 'subscription';
      }
    };

    const setPlan = (button) => {
      if (!button) return;

      planButtons.forEach((item) => item.classList.toggle('is-active', item === button));

      if (sellingPlanInput) {
        sellingPlanInput.value = button.dataset.sellingPlanId || '';
        sellingPlanInput.disabled = false;
      }

      if (subscriptionPrice) subscriptionPrice.textContent = button.dataset.planPrice || '';
      if (subscriptionCompare) subscriptionCompare.textContent = button.dataset.planComparePrice || '';
      if (subscriptionPerDelivery) subscriptionPerDelivery.textContent = button.dataset.planPerDelivery || '';
      if (subscriptionDiscount) subscriptionDiscount.textContent = button.dataset.planDiscount || '';
      if (subscriptionPlanCopy) subscriptionPlanCopy.textContent = button.dataset.planName || '';

      setPurchaseType('subscription');
    };

    productHero.querySelectorAll('[data-ds-product-flavor]').forEach((button) => {
      button.addEventListener('click', () => {
        const accent = button.dataset.accentColor || '#fb5373';
        const pale = button.dataset.paleColor || '#ffeef1';
        const variantId = button.dataset.variantId || '';
        productHero.style.setProperty('--ds-product-accent', accent);
        productHero.style.setProperty('--ds-product-pale', pale);

        productHero.querySelectorAll('[data-ds-product-flavor]').forEach((item) => {
          const isActive = variantId ? item.dataset.variantId === variantId : item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (variantId && variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (button.dataset.image && mainImage) {
          mainImage.src = button.dataset.image;
          mainImage.srcset = '';

          productHero.querySelectorAll('[data-ds-product-gallery-thumb]').forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb.dataset.image === button.dataset.image);
          });
        }

        if (button.dataset.flavorTitle && flavorName) {
          flavorName.textContent = button.dataset.flavorTitle;
        }
      });
    });

    planButtons.forEach((button) => {
      button.addEventListener('click', () => setPlan(button));
    });

    purchaseTypeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const type = button.dataset.dsPurchaseType;
        setPurchaseType(type);

        if (type === 'subscription' && sellingPlanInput && !sellingPlanInput.value) {
          setPlan(planButtons[0]);
        }
      });
    });

    productHero.querySelectorAll('.ds-product__quantity').forEach((quantity) => {
      const input = quantity.querySelector('.ds-product__qty-input');
      const minus = quantity.querySelector('[name="minus"]');
      const plus = quantity.querySelector('[name="plus"]');
      if (!input || !minus || !plus) return;

      minus.addEventListener('click', () => {
        const min = Number(input.min || 1);
        const nextValue = Math.max(min, Number(input.value || min) - 1);
        input.value = String(nextValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus.addEventListener('click', () => {
        const nextValue = Number(input.value || 1) + 1;
        input.value = String(nextValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    let addInProgress = false;
    const addProductToCart = async () => {
      if (!productForm || !variantInput?.value || addButton?.disabled || addInProgress) return;

      addInProgress = true;
      addButton?.setAttribute('aria-busy', 'true');
      if (addButton) addButton.disabled = true;

      try {
        const quantityInput = productForm.querySelector('[name="quantity"]');
        const item = {
          id: Number(variantInput.value),
          quantity: Math.max(1, Number(quantityInput?.value || 1)),
        };

        if (sellingPlanInput?.value && !sellingPlanInput.disabled) {
          item.selling_plan = Number(sellingPlanInput.value);
        }

        const rootUrl = window.Shopify?.routes?.root || '/';
        const cartItemsComponents = Array.from(document.querySelectorAll('cart-items-component'));
        const sections = cartItemsComponents.map((component) => component.dataset.sectionId).filter(Boolean);
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [item],
            sections,
            sections_url: window.location.pathname,
          }),
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(result.description || result.message || 'Unable to add this product to the cart.');
        }

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: result,
            sourceId: 'dayshift-product-form',
            data: {
              source: 'dayshift-product-form',
              itemCount: result.item_count,
              variantId: String(item.id),
              sections: result.sections || {},
            },
          },
        }));

        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.assign(`${rootUrl}cart`);
        }
      } catch (error) {
        console.error('DayShift add to cart failed:', error);
        window.alert(error.message || 'Unable to add this product to the cart.');
      } finally {
        addInProgress = false;
        addButton?.removeAttribute('aria-busy');
        if (addButton) addButton.disabled = false;
      }
    };

    addButton?.addEventListener('click', addProductToCart);
    productForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      addProductToCart();
    });
  });
};

bindProductHero();
document.addEventListener('shopify:section:load', bindProductHero);
